import SimplePaymentService from '../service/SimplePaymentService'
import SimplePayment, { SimplePaymentRetrieve, SimplePaymentStatus } from '../domain/SimplePayment'

import React, { useState } from 'react'
import { Form, Row, Col, notification, Typography, Input, Space, Button, Select, Result } from 'antd'
const { Option } = Select
const { Search } = Input
const { Title } = Typography

const SimplePaymentForm: React.FC = () => {
    const [form] = Form.useForm()
    const [apiNotification, contextNotification] = notification.useNotification()
    const [loading, setLoading] = useState<boolean>(false)
    const [disabledSimplePaymentId, setDisabledSimplePaymentId] = useState<boolean>(false)
    const [simplePayment, setSimplePayment] = useState<SimplePaymentRetrieve | null>(null)
    const [reasonRequired, setReasonRequired] = useState<boolean>(false)
    const [result, setResult] = useState<boolean>(false)
    const [simplePaymentStatuses, setSimplePaymentStatuses] = useState<SimplePaymentStatus[]>([])

    const onSearch = (simplePaymentId: string) => {
        setDisabledSimplePaymentId(true)
        setSimplePaymentStatuses([])
        SimplePaymentService.retrieve(simplePaymentId)
            .then((response) => {
                const simplePaymentStatusesTemp = SimplePayment.statuses(response)
                setSimplePaymentStatuses(simplePaymentStatusesTemp)

                setSimplePayment(response)
                form.setFieldsValue(response)

                const status = simplePaymentStatusesTemp.find((status) => status.value === response.status)
                if (status) setReasonRequired(status.needReason)
            })
            .catch(() => {
                setDisabledSimplePaymentId(false)
                apiNotification.open({
                    message: 'Retrieve Simple Payment Failed',
                    description: 'Simple Payment not Existent. Please try again with another Simple Payment ID',
                    placement: 'top',
                })
            })
    }

    const onFinish = () => {
        setLoading(true)

        const simplePaymentId = simplePayment?.id as string
        const values = form.getFieldsValue() as SimplePaymentRetrieve

        SimplePaymentService.update(simplePaymentId, values)
            .then(() => {
                setResult(true)
            })
            .catch(() => {
                setDisabledSimplePaymentId(false)
                apiNotification.open({
                    message: 'Update Simple Payment Failed',
                    description: 'Something went wrong. Please try again later. If the issue keep happening, please contact Customer Support',
                    placement: 'top',
                })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const reset = () => {
        form.resetFields()

        setResult(false)
        setSimplePayment(null)
        setDisabledSimplePaymentId(false)
    }

    return (
        <>
            {contextNotification}
            {result && simplePayment && (
                <Result
                    status="success"
                    title="Update Simple Payment Success"
                    subTitle={`Simple Payment ${simplePayment.id} Updated Successfully`}
                    extra={[
                        <Button type="primary" key="console" onClick={reset}>
                            Back
                        </Button>,
                    ]}
                />
            )}

            {!result && (
                <Form name="simple-payment" layout="vertical" onFinish={onFinish} form={form}>
                    <Row>
                        <Col>
                            <Title level={2}>Simulate Simple Payment</Title>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 8 }}>
                            <Title level={5}>Search by Simple Payment ID</Title>
                            <Form.Item>
                                <Search placeholder="Input Simple Payment ID" disabled={disabledSimplePaymentId} onSearch={onSearch} />
                            </Form.Item>

                            {simplePayment && (
                                <>
                                    <Title level={5}>Simple Payment Information</Title>
                                    <Form.Item label="Wallex Reference" name="wallexRef">
                                        <Input disabled={true} />
                                    </Form.Item>

                                    <Form.Item label="Status" name="status">
                                        <Select
                                            placeholder="Select Simple Payment Status"
                                            onChange={(key) => {
                                                const status = simplePaymentStatuses.find((status) => status.value === key)
                                                if (status) setReasonRequired(status.needReason)
                                            }}
                                        >
                                            {simplePaymentStatuses.map((status) => (
                                                <Option key={status.value} value={status.value}>
                                                    {status.description}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    {reasonRequired && (
                                        <Form.Item
                                            label="Reason"
                                            name="failureReason"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input Reason',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    )}

                                    <Form.Item label=" " colon={false}>
                                        <Space>
                                            <Button type="primary" htmlType="submit" loading={loading}>
                                                Update
                                            </Button>
                                            <Button htmlType="submit" onClick={reset}>
                                                Reset
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </>
                            )}
                        </Col>
                    </Row>
                </Form>
            )}
        </>
    )
}

export default SimplePaymentForm
